import { useState, useEffect } from 'react';
import { supabase } from '../supabase';

function Clientes() {
  const [clientes, setClientes] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [filtroServico, setFiltroServico] = useState('todos');
  const [novoCliente, setNovoCliente] = useState({
    nome: '', valor: '', vencimento: '', servico: '360',
    tipo_pagamento: 'recorrente', data_inicio: '', data_fim: ''
  });

  const formatarMoeda = (valor) => Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const calcularMesesRestantes = (dataFim) => {
    if (!dataFim) return null;
    const hoje = new Date();
    const fim = new Date(dataFim);
    return (fim.getFullYear() - hoje.getFullYear()) * 12 + (fim.getMonth() - hoje.getMonth());
  };

  useEffect(() => { buscarClientes(); }, []);

  const buscarClientes = async () => {
    setCarregando(true);
    const { data, error } = await supabase
      .from('clientes')
      .select('*, ads_config_clientes(*), social_config_clientes(*)')
      .eq('ativo', true)
      .order('nome');
    if (!error) setClientes(data || []);
    setCarregando(false);
  };

const adicionarCliente = async () => {
  if (!novoCliente.nome || !novoCliente.valor) return;
  const { error } = await supabase.from('clientes').insert({
    nome: novoCliente.nome,
    valor: parseFloat(novoCliente.valor.toString().replace(',', '.')) || 0,
    vencimento: novoCliente.vencimento ? parseInt(novoCliente.vencimento) : null,
    servico: novoCliente.servico,
    tipo_pagamento: novoCliente.tipo_pagamento,
    data_inicio: novoCliente.data_inicio || null,
    data_fim: novoCliente.data_fim || null,
  });
  if (error) {
    console.error('Erro ao salvar cliente:', error);
    return;
  }
  buscarClientes();
  setNovoCliente({ nome: '', valor: '', vencimento: '', servico: '360', tipo_pagamento: 'recorrente', data_inicio: '', data_fim: '' });
  setMostrarForm(false);
};

  const atualizarCliente = async (id, campo, valor) => {
    await supabase.from('clientes').update({ [campo]: valor }).eq('id', id);
    buscarClientes();
    setClienteSelecionado(prev => prev ? { ...prev, [campo]: valor } : prev);
  };

  const toggleModulo = async (cliente, modulo) => {
    const campoAtual = cliente[modulo];
    await supabase.from('clientes').update({ [modulo]: !campoAtual }).eq('id', cliente.id);
    if (modulo === 'modulo_ads' && !campoAtual) {
      const { data: cfg } = await supabase.from('ads_config_clientes').select('id').eq('cliente_id', cliente.id).single();
      if (!cfg) await supabase.from('ads_config_clientes').insert({ cliente_id: cliente.id });
    }
    if (modulo === 'modulo_social' && !campoAtual) {
      const { data: cfg } = await supabase.from('social_config_clientes').select('id').eq('cliente_id', cliente.id).single();
      if (!cfg) await supabase.from('social_config_clientes').insert({ cliente_id: cliente.id });
    }
    buscarClientes();
    setClienteSelecionado(prev => prev ? { ...prev, [modulo]: !campoAtual } : prev);
  };

  const toggleCanal = async (cliente, campo) => {
    const configAtual = cliente.ads_config_clientes;
    const valorAtual = configAtual?.[campo];
    if (configAtual) {
      await supabase.from('ads_config_clientes').update({ [campo]: !valorAtual }).eq('cliente_id', cliente.id);
    } else {
      await supabase.from('ads_config_clientes').insert({ cliente_id: cliente.id, [campo]: true });
    }
    buscarClientes();
    setClienteSelecionado(prev => prev ? {
      ...prev,
      ads_config_clientes: { ...(prev.ads_config_clientes || {}), [campo]: !valorAtual }
    } : prev);
  };

  const removerCliente = async (id) => {
    await supabase.from('clientes').update({ ativo: false }).eq('id', id);
    setClienteSelecionado(null);
    buscarClientes();
  };

  const clientesFiltrados = filtroServico === 'todos' ? clientes : clientes.filter(c => c.servico === filtroServico);
  const total360 = clientes.filter(c => c.servico === '360').length;
  const totalCaptacao = clientes.filter(c => c.servico === 'captacao').length;
  const receitaTotal = clientes.reduce((acc, c) => acc + Number(c.valor), 0);

  if (carregando) return <div className="flex items-center justify-center h-64"><p style={{ color: '#555' }}>Carregando...</p></div>;

  return (
    <div>
      <div className="mb-6 flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-white">Clientes</h2>
          <p className="mt-1" style={{ color: '#555' }}>Central de clientes ativos</p>
        </div>
        <button onClick={() => setMostrarForm(!mostrarForm)}
          className="px-4 py-2 rounded-lg text-sm font-medium"
          style={{ backgroundColor: '#DCF127', color: '#0a0a0a' }}>
          + Novo Cliente
        </button>
      </div>

      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="rounded-xl p-5" style={{ backgroundColor: '#111', border: '1px solid #1a1a1a' }}>
          <p className="text-sm mb-1" style={{ color: '#555' }}>Marketing 360</p>
          <p className="text-2xl font-bold" style={{ color: '#60a5fa' }}>{total360} clientes</p>
        </div>
        <div className="rounded-xl p-5" style={{ backgroundColor: '#111', border: '1px solid #1a1a1a' }}>
          <p className="text-sm mb-1" style={{ color: '#555' }}>Captação</p>
          <p className="text-2xl font-bold" style={{ color: '#c084fc' }}>{totalCaptacao} clientes</p>
        </div>
        <div className="rounded-xl p-5" style={{ backgroundColor: '#111', border: '1px solid #1a1a1a' }}>
          <p className="text-sm mb-1" style={{ color: '#555' }}>Receita Mensal</p>
          <p className="text-2xl font-bold" style={{ color: '#22c55e' }}>{formatarMoeda(receitaTotal)}</p>
        </div>
      </div>

      {mostrarForm && (
        <div className="rounded-xl p-6 mb-6" style={{ backgroundColor: '#111', border: '1px solid #1a1a1a' }}>
          <h3 className="text-white font-semibold mb-4">Novo Cliente</h3>
          <div className="grid grid-cols-3 gap-4">
            {[
              { label: 'Nome', key: 'nome', type: 'text', placeholder: 'Nome do cliente' },
              { label: 'Valor Mensal (R$)', key: 'valor', type: 'number', placeholder: '0,00' },
              { label: 'Dia de Vencimento', key: 'vencimento', type: 'number', placeholder: '10' },
              { label: 'Início do Contrato', key: 'data_inicio', type: 'date' },
              { label: 'Fim do Contrato', key: 'data_fim', type: 'date' },
            ].map(({ label, key, type, placeholder }) => (
              <div key={key} className="flex flex-col gap-1">
                <label className="text-xs" style={{ color: '#555' }}>{label}</label>
                <input type={type} value={novoCliente[key]} placeholder={placeholder}
                  onChange={(e) => setNovoCliente({ ...novoCliente, [key]: e.target.value })}
                  className="rounded-lg px-3 py-2 text-sm outline-none text-white"
                  style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }} />
              </div>
            ))}
            <div className="flex flex-col gap-1">
              <label className="text-xs" style={{ color: '#555' }}>Serviço</label>
              <select value={novoCliente.servico}
                onChange={(e) => setNovoCliente({ ...novoCliente, servico: e.target.value })}
                className="rounded-lg px-3 py-2 text-sm outline-none text-white"
                style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }}>
                <option value="360">Marketing 360</option>
                <option value="captacao">Captação</option>
              </select>
            </div>
          </div>
          <div className="flex gap-3 mt-4">
            <button onClick={adicionarCliente}
              className="px-4 py-2 rounded-lg text-sm font-medium"
              style={{ backgroundColor: '#DCF127', color: '#0a0a0a' }}>Salvar</button>
            <button onClick={() => setMostrarForm(false)}
              className="px-4 py-2 rounded-lg text-sm font-medium"
              style={{ backgroundColor: '#1a1a1a', color: '#aaa' }}>Cancelar</button>
          </div>
        </div>
      )}

      <div className="flex gap-2 mb-4">
        {[{ id: 'todos', label: 'Todos' }, { id: '360', label: 'Marketing 360' }, { id: 'captacao', label: 'Captação' }].map((f) => (
          <button key={f.id} onClick={() => setFiltroServico(f.id)}
            className="px-4 py-2 rounded-lg text-sm font-medium transition-all"
            style={{
              backgroundColor: filtroServico === f.id ? '#DCF127' : '#111',
              color: filtroServico === f.id ? '#0a0a0a' : '#666',
              border: filtroServico === f.id ? 'none' : '1px solid #1a1a1a',
            }}>
            {f.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-3 gap-4">
        {clientesFiltrados.map((cliente) => {
          const mesesRestantes = calcularMesesRestantes(cliente.data_fim);
          const ultimoMes = mesesRestantes !== null && mesesRestantes <= 1;
          return (
            <div key={cliente.id} onClick={() => setClienteSelecionado(cliente)}
              className="rounded-xl cursor-pointer transition-all p-5"
              style={{ backgroundColor: '#111', border: '1px solid #1a1a1a' }}
              onMouseEnter={(e) => e.currentTarget.style.border = '1px solid #333'}
              onMouseLeave={(e) => e.currentTarget.style.border = '1px solid #1a1a1a'}>
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h3 className="text-white font-semibold">{cliente.nome}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full mt-1 inline-block"
                    style={{
                      backgroundColor: cliente.servico === '360' ? '#1e3a5f' : '#2e1a4a',
                      color: cliente.servico === '360' ? '#60a5fa' : '#c084fc'
                    }}>
                    {cliente.servico === '360' ? 'Marketing 360' : 'Captação'}
                  </span>
                </div>
                <p className="font-semibold text-sm" style={{ color: '#22c55e' }}>{formatarMoeda(Number(cliente.valor))}</p>
              </div>
              <div className="flex gap-1 mb-3">
                {cliente.modulo_ads && <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ background: '#E6F1FB', color: '#185FA5' }}>Ads</span>}
                {cliente.modulo_social && <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ background: '#EAF3DE', color: '#3B6D11' }}>Social</span>}
                {cliente.modulo_financeiro && <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ background: '#FAEEDA', color: '#854F0B' }}>Financeiro</span>}
              </div>
              <div className="text-xs space-y-1" style={{ color: '#555' }}>
                <p>Vence dia {cliente.vencimento}</p>
                {cliente.data_fim && <p>{mesesRestantes > 0 ? `${mesesRestantes} meses restantes` : 'Contrato encerrado'}</p>}
              </div>
              {ultimoMes && (
                <div className="mt-3 rounded-lg px-3 py-2" style={{ backgroundColor: '#2a1f00', border: '1px solid #4a3500' }}>
                  <p className="text-xs font-medium" style={{ color: '#f59e0b' }}>⚠️ Último mês de contrato</p>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Modal */}
      {clienteSelecionado && (
        <div className="fixed inset-0 flex items-center justify-center z-50 p-4 overflow-y-auto"
          style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}
          onClick={() => setClienteSelecionado(null)}>
          <div className="rounded-2xl w-full max-w-2xl p-8 my-4"
            style={{ backgroundColor: '#111', border: '1px solid #333' }}
            onClick={(e) => e.stopPropagation()}>

            <div className="flex justify-between items-start mb-6">
              <div>
                <input
                  className="text-2xl font-bold text-white bg-transparent outline-none pb-1"
                  style={{ borderBottom: '1px solid #333' }}
                  defaultValue={clienteSelecionado.nome}
                  onBlur={(e) => atualizarCliente(clienteSelecionado.id, 'nome', e.target.value)} />
                <span className="text-xs px-2 py-0.5 rounded-full mt-2 inline-block"
                  style={{
                    backgroundColor: clienteSelecionado.servico === '360' ? '#1e3a5f' : '#2e1a4a',
                    color: clienteSelecionado.servico === '360' ? '#60a5fa' : '#c084fc'
                  }}>
                  {clienteSelecionado.servico === '360' ? 'Marketing 360' : 'Captação'}
                </span>
              </div>
              <button onClick={() => setClienteSelecionado(null)} style={{ color: '#555' }} className="text-xl hover:text-white">✕</button>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-5">
              {[
                { label: 'Valor Mensal (R$)', campo: 'valor', type: 'number' },
                { label: 'Dia de Vencimento', campo: 'vencimento', type: 'number' },
                { label: 'Início do Contrato', campo: 'data_inicio', type: 'date' },
                { label: 'Fim do Contrato', campo: 'data_fim', type: 'date' },
              ].map(({ label, campo, type }) => (
                <div key={campo} className="flex flex-col gap-2">
                  <label className="text-xs uppercase tracking-wide" style={{ color: '#555' }}>{label}</label>
                  <input type={type}
                    defaultValue={type === 'date' ? clienteSelecionado[campo]?.split('T')[0] : clienteSelecionado[campo]}
                    onBlur={(e) => atualizarCliente(clienteSelecionado.id, campo, type === 'number' ? parseFloat(e.target.value) : e.target.value)}
                    className="rounded-lg px-3 py-2 text-sm outline-none text-white"
                    style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }} />
                </div>
              ))}
              <div className="flex flex-col gap-2">
                <label className="text-xs uppercase tracking-wide" style={{ color: '#555' }}>Serviço</label>
                <select defaultValue={clienteSelecionado.servico}
                  onChange={(e) => atualizarCliente(clienteSelecionado.id, 'servico', e.target.value)}
                  className="rounded-lg px-3 py-2 text-sm outline-none text-white"
                  style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }}>
                  <option value="360">Marketing 360</option>
                  <option value="captacao">Captação</option>
                </select>
              </div>
            </div>

            {/* Módulos */}
            <div className="rounded-xl p-4 mb-4" style={{ backgroundColor: '#1a1a1a', border: '1px solid #222' }}>
              <p className="text-xs uppercase tracking-wide mb-3" style={{ color: '#555' }}>Módulos ativos</p>
              <div className="flex flex-col gap-3">
                {[
                  { modulo: 'modulo_ads', label: 'Ads', desc: 'Lançamento de métricas, dashboard e IA de briefing' },
                  { modulo: 'modulo_social', label: 'Social Media', desc: 'Checklist mensal e calendário de conteúdo' },
                  { modulo: 'modulo_financeiro', label: 'Financeiro', desc: 'Receitas e controle de pagamentos' },
                ].map(({ modulo, label, desc }) => (
                  <div key={modulo} className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-white font-medium">{label}</p>
                      <p className="text-xs" style={{ color: '#555' }}>{desc}</p>
                    </div>
                    <button onClick={() => toggleModulo(clienteSelecionado, modulo)}
                      className="relative w-10 h-6 rounded-full transition-all flex-shrink-0"
                      style={{ backgroundColor: clienteSelecionado[modulo] ? '#DCF127' : '#333' }}>
                      <div className="absolute w-4 h-4 rounded-full bg-white top-1 transition-all"
                        style={{ left: clienteSelecionado[modulo] ? '22px' : '4px' }} />
                    </button>
                  </div>
                ))}
              </div>
            </div>

            {/* Canais de Ads */}
            {clienteSelecionado.modulo_ads && (
              <div className="rounded-xl p-4 mb-4" style={{ backgroundColor: '#1a1a1a', border: '1px solid #222' }}>
                <p className="text-xs uppercase tracking-wide mb-3" style={{ color: '#555' }}>Canais de Ads</p>
                <div className="flex flex-col gap-3">
                  {[
                    { campo: 'canal_meta', label: 'Meta Ads', desc: 'Facebook e Instagram Ads' },
                    { campo: 'canal_google', label: 'Google Ads', desc: 'Search, Display e YouTube' },
                  ].map(({ campo, label, desc }) => (
                    <div key={campo} className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-white font-medium">{label}</p>
                        <p className="text-xs" style={{ color: '#555' }}>{desc}</p>
                      </div>
                      <button onClick={() => toggleCanal(clienteSelecionado, campo)}
                        className="relative w-10 h-6 rounded-full transition-all flex-shrink-0"
                        style={{ backgroundColor: clienteSelecionado.ads_config_clientes?.[campo] ? '#DCF127' : '#333' }}>
                        <div className="absolute w-4 h-4 rounded-full bg-white top-1 transition-all"
                          style={{ left: clienteSelecionado.ads_config_clientes?.[campo] ? '22px' : '4px' }} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {calcularMesesRestantes(clienteSelecionado.data_fim) !== null &&
              calcularMesesRestantes(clienteSelecionado.data_fim) <= 1 && (
              <div className="rounded-lg px-4 py-3 mb-4" style={{ backgroundColor: '#2a1f00', border: '1px solid #4a3500' }}>
                <p className="text-sm font-medium" style={{ color: '#f59e0b' }}>⚠️ Último mês de contrato — agende a reunião de renovação!</p>
              </div>
            )}

            <div className="flex justify-between items-center pt-5" style={{ borderTop: '1px solid #1a1a1a' }}>
              <button onClick={() => removerCliente(clienteSelecionado.id)}
                className="px-4 py-2 rounded-lg text-sm font-medium"
                style={{ backgroundColor: '#2a0a0a', color: '#ef4444' }}>
                Desativar Cliente
              </button>
              <button onClick={() => setClienteSelecionado(null)}
                className="px-4 py-2 rounded-lg text-sm font-medium"
                style={{ backgroundColor: '#DCF127', color: '#0a0a0a' }}>
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Clientes;